import { render, staticRenderFns } from "./ModalCadastro.vue?vue&type=template&id=072004e9&scoped=true"
import script from "./ModalCadastro.vue?vue&type=script&lang=js"
export * from "./ModalCadastro.vue?vue&type=script&lang=js"
import style0 from "./ModalCadastro.vue?vue&type=style&index=0&id=072004e9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "072004e9",
  null
  
)

export default component.exports